import clsx from "clsx";
import { FunctionComponent, useState } from "react";

import * as styles from "@ui/components/article/ShareButtons/components/ShareButtonsSharePopover/ShareButtonsSharePopover.css";
import * as shareButtonsStyles from "@ui/components/article/ShareButtons/ShareButtons.css";
import LinkIcon from "@ui/components/icon/LinkIcon";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
}

/**
 * Copy Link button component for the share popover
 */
const ShareButtonsCopyLink: FunctionComponent<Props> = ({ url }) => {
  const [copyFeedback, setCopyFeedback] = useState<string | null>(null);
  const analytics = useAnalytics();

  const handleCopyLink = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "copy link" },
    });

    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopyFeedback("Link copied!");
        setTimeout(() => {
          setCopyFeedback(null);
        }, 2000);
      })
      .catch((err) => {
        console.error(err);
        setCopyFeedback("Failed to copy");
        setTimeout(() => {
          setCopyFeedback(null);
        }, 2000);
      });
  };

  return (
    <button
      onClick={handleCopyLink}
      className={styles.shareOption}
      aria-label="Copy link"
    >
      <span
        className={clsx(
          shareButtonsStyles.button.standard,
          styles.shareIconContainer,
        )}
      >
        <LinkIcon className={styles.shareIcon} />
      </span>
      <span className={styles.shareLabel}>Copy Link</span>
      {copyFeedback && (
        <span className={styles.copyFeedback}>{copyFeedback}</span>
      )}
    </button>
  );
};

export default ShareButtonsCopyLink;
